var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13943_9596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00004 5.99992H6.00671M10 9.99992H10.0067M10.6667 5.33325L5.33337 10.6666M4.88922 2.54572C5.42511 2.50295 5.93385 2.29222 6.34302 1.94353C7.29786 1.12983 8.70222 1.12983 9.65706 1.94353C10.0662 2.29222 10.575 2.50295 11.1109 2.54572C12.3614 2.64551 13.3544 3.63855 13.4542 4.8891C13.497 5.42499 13.7077 5.93373 14.0564 6.3429C14.8701 7.29773 14.8701 8.7021 14.0564 9.65694C13.7077 10.0661 13.497 10.5749 13.4542 11.1107C13.3544 12.3613 12.3614 13.3543 11.1109 13.4541C10.575 13.4969 10.0662 13.7076 9.65706 14.0563C8.70222 14.87 7.29786 14.87 6.34302 14.0563C5.93385 13.7076 5.42511 13.4969 4.88922 13.4541C3.63867 13.3543 2.64563 12.3613 2.54584 11.1107C2.50307 10.5749 2.29235 10.0661 1.94365 9.65694C1.12995 8.7021 1.12995 7.29773 1.94365 6.3429C2.29235 5.93373 2.50307 5.42499 2.54584 4.8891C2.64563 3.63855 3.63867 2.64551 4.88922 2.54572ZM6.33337 5.99992C6.33337 6.18401 6.18414 6.33325 6.00004 6.33325C5.81595 6.33325 5.66671 6.18401 5.66671 5.99992C5.66671 5.81582 5.81595 5.66659 6.00004 5.66659C6.18414 5.66659 6.33337 5.81582 6.33337 5.99992ZM10.3334 9.99992C10.3334 10.184 10.1841 10.3333 10 10.3333C9.81595 10.3333 9.66671 10.184 9.66671 9.99992C9.66671 9.81582 9.81595 9.66658 10 9.66658C10.1841 9.66658 10.3334 9.81582 10.3334 9.99992Z",
    stroke: "#2E7D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13943_9596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountIcon);
export default __webpack_public_path__ + "static/media/discount_icon.6139887251da64345058e92e9cf1a09b.svg";
export { ForwardRef as ReactComponent };